export default "__VITE_ASSET__Qo1rdY48__"